import type { UserManager } from "oidc-client-ts";

/**
 * Returns a valid ID token, attempting silent renew if the current one is expired.
 *
 * Note: This project’s APIs expect the **ID token** in `Authorization: Bearer <token>`.
 */
export async function getValidIdToken(userManager: UserManager): Promise<string | null> {
  const user = await userManager.getUser();
  if (!user) return null;

  if (!user.id_token || user.id_token.trim() === "") return null;

  if (user.expired) {
    const renewed = await userManager.signinSilent();
    return renewed?.id_token ?? null;
  }

  return user.id_token;
}

